import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import MuiTableCell from "@mui/material/TableCell";
import MuiTableBody from "@mui/material/TableBody";
import MuiTableRow from "@mui/material/TableRow";
import CellDateTime from "./CellDateTime.js";
import CellText from "./CellText.js";
import CellValue from "./CellValue.js";
import CellWithTrend from "./CellWithTrend.js";
import { getRatio } from "../utils/trends.js";
import CellIcon from "./CellIcon.js";
import CellLink from "./CellLink.js";
import CellWithAbsoluteTrend from "./CellWithAbsoluteTrend.js";
function getComparator(order, colIndex) {
  return (a, b) => descendingComparator(a[colIndex], b[colIndex], order === "desc");
}
function getComparisonComparator(order, comparisonIndex, valueIndex) {
  return (a, b) => {
    const aRatio = getRatio(a[valueIndex], a[comparisonIndex]);
    const bRatio = getRatio(b[valueIndex], b[comparisonIndex]);
    return descendingComparator(aRatio, bRatio, order === "desc");
  };
}
function descendingComparator(a, b, desc) {
  if ((a === void 0 || a === null) && (b === void 0 || b === null)) {
    return 0;
  }
  if (a === void 0 || a === null) {
    return 1;
  }
  if (b === void 0 || b === null) {
    return -1;
  }
  if (b < a) {
    return desc ? -1 : 1;
  }
  if (b > a) {
    return desc ? 1 : -1;
  }
  return 0;
}
const TableBody = (t0) => {
  const $ = c(21);
  const {
    columns,
    data: tableData,
    order,
    orderBy,
    filterValue
  } = t0;
  const {
    data,
    columns: columnsData
  } = tableData;
  const filterData = _temp;
  let t1;
  if ($[0] !== columns || $[1] !== columnsData || $[2] !== data || $[3] !== filterValue || $[4] !== order || $[5] !== orderBy) {
    bb0: {
      const colIndex = columnsData?.findIndex((col) => col.key === orderBy);
      const column = columnsData?.[colIndex ?? -1];
      const searchableColumnIndices = columns.map(_temp2).filter(_temp3);
      if (colIndex === -1 || !column) {
        t1 = filterData(data, filterValue, searchableColumnIndices);
        break bb0;
      }
      if (column.comparison) {
        let t22;
        if ($[7] !== column.key || $[8] !== columns) {
          let t32;
          if ($[10] !== column.key) {
            t32 = (col_1) => col_1.comparison?.key === column.key;
            $[10] = column.key;
            $[11] = t32;
          } else {
            t32 = $[11];
          }
          t22 = columns.find(t32);
          $[7] = column.key;
          $[8] = columns;
          $[9] = t22;
        } else {
          t22 = $[9];
        }
        const columnConfig = t22;
        const keyToCompare = columnConfig?.comparison?.key;
        const keyToValue = columnConfig?.value?.key;
        const comparisonIndex = columnsData?.findIndex((col_2) => col_2.key === keyToCompare);
        const valueIndex = columnsData?.findIndex((col_3) => col_3.key === keyToValue);
        if (comparisonIndex === -1 || valueIndex === -1) {
          t1 = data;
          break bb0;
        }
        t1 = [...filterData(data, filterValue, searchableColumnIndices)].sort(getComparisonComparator(order, comparisonIndex, valueIndex));
        break bb0;
      }
      t1 = [...filterData(data, filterValue, searchableColumnIndices)].sort(getComparator(order, colIndex));
    }
    $[0] = columns;
    $[1] = columnsData;
    $[2] = data;
    $[3] = filterValue;
    $[4] = order;
    $[5] = orderBy;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const visibleRows = t1;
  let t2;
  if ($[12] !== columns || $[13] !== columnsData || $[14] !== visibleRows) {
    let t32;
    if ($[16] !== columns || $[17] !== columnsData) {
      t32 = (row_0, rowIndex) => /* @__PURE__ */ jsx(MuiTableRow, { children: columns.map((col_4, colIndex_0) => {
        const {
          type,
          comparison,
          value
        } = col_4;
        const columnDataIndex = columnsData?.findIndex((column_0) => column_0.key === col_4.value.key);
        if (columnDataIndex === -1) {
          return null;
        }
        const colDataKey = value.key;
        const columnData = columnsData[columnDataIndex];
        if (!columnData) {
          return null;
        }
        const columnType = columnData.type;
        const format = {
          currency: columnData.currency,
          short: columnData.short === false ? false : true,
          ...columnData.precision !== void 0 ? {
            precision: columnData.precision
          } : {}
        };
        const numeric = columnType !== "string" && columnType !== "boolean" || comparison !== void 0;
        return /* @__PURE__ */ jsxs(MuiTableCell, { className: type, align: numeric ? "right" : "left", children: [
          type === "icon" && /* @__PURE__ */ jsx(CellIcon, { type: row_0[columnDataIndex] }),
          columnType !== "string" && columnType !== "boolean" && columnType !== "duration" && columnType !== "icon" && columnType !== "link" && type !== "trend" && !comparison && /* @__PURE__ */ jsx(CellValue, { columnType, type, value: row_0[columnDataIndex], format }),
          columnType === "duration" && !comparison && /* @__PURE__ */ jsx(CellDateTime, { columnType, value: row_0[columnDataIndex], display: col_4.display_format }),
          columnType === "link" && (row_0[columnDataIndex] === null ? /* @__PURE__ */ jsx(CellText, { text: "—" }) : /* @__PURE__ */ jsx(CellLink, { text: `${row_0[columnDataIndex]}`, url: `${row_0[columnDataIndex]}` })),
          columnType === "string" && type !== "icon" && /* @__PURE__ */ jsx(CellText, { text: row_0[columnDataIndex] === null ? "—" : `${row_0[columnDataIndex]}` }),
          type === "trend" && (columnType === "float" || columnType === "integer" || columnType === "money" || columnType === "percentage") && /* @__PURE__ */ jsx(CellWithAbsoluteTrend, { value: row_0[columnDataIndex], desiredTrend: col_4.desired_trend ?? "positive", columnType, type, format }),
          comparison && (() => {
            const columnConfig_0 = columns[colIndex_0];
            const keyToCompare_0 = columnConfig_0.comparison.key;
            const keyToValue_0 = columnConfig_0.value.key;
            const valueToCompare = row_0[columnsData.findIndex((col_5) => col_5.key === keyToCompare_0)];
            const value_0 = row_0[columnsData.findIndex((col_6) => col_6.key === keyToValue_0)];
            return /* @__PURE__ */ jsx(CellWithTrend, { value: value_0, comparison: valueToCompare, desiredTrend: columnConfig_0.desired_trend ?? "positive" });
          })()
        ] }, `td-${colDataKey}-${rowIndex}-${colIndex_0}`);
      }) }, rowIndex);
      $[16] = columns;
      $[17] = columnsData;
      $[18] = t32;
    } else {
      t32 = $[18];
    }
    t2 = visibleRows.map(t32);
    $[12] = columns;
    $[13] = columnsData;
    $[14] = visibleRows;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[19] !== t2) {
    t3 = /* @__PURE__ */ jsx(MuiTableBody, { children: t2 });
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
};
function _temp(data_0, t0, t1) {
  const filterValue_0 = t0 === void 0 ? "" : t0;
  const columnIndices = t1 === void 0 ? [] : t1;
  if (!filterValue_0 || filterValue_0.trim() === "" || columnIndices.length === 0) {
    return data_0;
  }
  const lowerFilter = filterValue_0.toLowerCase();
  return data_0.filter((row) => {
    for (const columnIndex of columnIndices) {
      const cellValue = row[columnIndex];
      if (cellValue !== void 0 && cellValue !== null && String(cellValue).toLowerCase().includes(lowerFilter)) {
        return true;
      }
    }
    return false;
  });
}
function _temp2(col_0, idx) {
  return col_0.searchable ? idx : -1;
}
function _temp3(idx_0) {
  return idx_0 !== -1;
}
export {
  TableBody as default
};
